import React, { useState, useRef, useEffect, useCallback } from "react";
import DataTable from "../../components/common/DataTable/DataTable";
import addIcon from "../../assets/images/icons/addIcon.png";
import filterIcon from "../../assets/images/icons/filterIcon.svg";
import searchIcon from "../../assets/images/icons/search.png";
import linkedIncidentIcon from "../../assets/images/icons/linkedIncidentIcon.svg";
import FilterCoreModal from "../../components/common/FilterCoreModal/FilterCoreModal";
// import viewIcon from "../../assets/images/icons/view.png";
// import editIcon from "../../assets/images/icons/edit.png";
// import FilterForm from "../../components/MyTasks/FilterForm/FilterForm";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../auth/authSlice";
import {
  useGetIncidentsQuery,
  useGetIncidentStatusQuery,
  useGetIncidentInsightsQuery,
  useGetIncidentGroupsQuery,
} from "./IncidentSlice";
import { nanoid } from "@reduxjs/toolkit";
import { Loader } from "../../components/common/Loader/Loader";
import { incidentStatus } from "../../enums/statuses";
import { hasAnyValue, sanitizeInputValue } from "../../utils/commonMethods";
import UserSelect from "../../components/common/UserSelect/UserSelect";
import DepartmentSelect from "../../components/common/Selectors/DepartmentSelect";
import SubDepartmentSelect from "../../components/common/Selectors/SubDepartmentSelect";
import AreaSelect from "../../components/common/Selectors/AreaSelect";
import CostCentreSelect from "../../components/common/Selectors/CostCentreSelect";

const Incidents = () => {
  const navigate = useNavigate();

  const initialFilters = localStorage.getItem("incidentFilters")
    ? JSON.parse(localStorage.getItem("incidentFilters"))
    : null;

  const user = useSelector(selectCurrentUser);
  const [incidentData, setIncidentData] = useState([]);
  const [incidentStatusData, setIncidentStatusData] = useState([]);
  const [insightsData, setInsightsData] = useState({});
  const [incidentColumns, setIncidentColumns] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [query, setQuery] = useState("");
  // const [retentionDateAfter, setRetentionDateAfter] = useState("");
  // const [retentionDateBefore, setRetentionDateBefore] = useState("");
  // const [isNearMissYes, setIsNearMissYes] = useState(false);
  // const [isNearMissNo, setIsNearMissNo] = useState(false);
  // const [createdOnAfter, setCreatedOnAfter] = useState("");
  // const [createdOnBefore, setCreatedOnBefore] = useState("");
  // const [sensitivityLevelId, setSensitivityLevelId] = useState("");
  // const [dateAfter, setDateAfter] = useState("");
  // const [dateBefore, setDateBefore] = useState("");

  const [filter, setFilter] = useState({
    statusId: initialFilters?.statusId,
    typeId: initialFilters?.typeId,
    subTypeId: initialFilters?.subTypeId,
    groupId: initialFilters?.groupId,
    departmentId: initialFilters?.departmentId,
    subDepartmentId: initialFilters?.subDepartmentId,
    areaId: initialFilters?.areaId,
    costCenterId: initialFilters?.costCenterId,
    createdById: initialFilters?.createdById,
    localMangerId: initialFilters?.localMangerId,
    seniorMangerId: initialFilters?.seniorMangerId,
    incidentAdvisorId: initialFilters?.incidentAdvisorId,
  });
  const [incidentGroupData, setIncidentGroupData] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [filterValues, setFilterValues] = useState({
    ...initialFilters,
    departmentId: initialFilters?.departmentId?.value,
    subDepartmentId: initialFilters?.subDepartmentId?.value,
    areaId: initialFilters?.areaId?.value,
    costCenterId: initialFilters?.costCenterId?.value,
    createdById: initialFilters?.createdById?.value,
    seniorMangerId: initialFilters?.seniorMangerId?.value,
    localMangerId: initialFilters?.localMangerId?.value,
    incidentAdvisorId: initialFilters?.incidentAdvisorId?.value,
  });
  const [insightsStatus, setInsightsStatus] = useState(
    initialFilters?.insightsStatus || ""
  );
  const [incidentOrderBy, setIncidentOrderBy] = useState("");
  const [orderByType, setOrderByType] = useState("Desc");
  const [isAscending, setIsAscending] = useState(false);

  const {
    data: incidents,
    isSuccess,
    isFetching,
  } = useGetIncidentsQuery({
    role: user.roles,
    page: pageNumber,
    query,
    incidentOrderBy,
    orderByType,
    ...filterValues,
  });

  const {
    data: statuses,
    // statusesIsLoading,
    // statusesIsSuccess,
    // statusesIsError,
  } = useGetIncidentStatusQuery();

  const {
    data: insights,
    // isLoading: insightsIsLoading,
    // isSuccess: insightsIsSuccess,
    // isError: insightsIsError,
  } = useGetIncidentInsightsQuery();

  const {
    data: incidentGroups,
    // isLoading: incidentGroupsIsLoading,
    // isSuccess: incidentGroupsIsSuccess,
    // isError: incidentGroupsIsError,
  } = useGetIncidentGroupsQuery();

  const generateColumns = useCallback(
    (data) => {
      if (data.length <= 0) {
        return;
      }

      const columns = Object.keys(data[0])
        .map((field) => {
          if (field === "guid") return null;
          if (field === "type") {
            return null;
          }
          if (field === "subType") {
            return null;
          }
          if (field === "pageSettings") {
            return null;
          }
          if (field === "doesContainsLinkedIncidents") {
            return null;
          }

          let columnConfig = {
            key: nanoid(),
            field,
            headerText: field
              .replace(/([A-Z])/g, " $1")
              .trim()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" "),
            alignment: "left",
            template: null,
            headerTemplate: null,
            width: "190px",
            allowSorting: true,
          };

          if (field === "id") {
            columnConfig.headerText = "ID";
            columnConfig.width = "100px";
            columnConfig.template = (props) => {
              return <p className="m-0">{props[field]}</p>;
            };
            columnConfig.headerTemplate = (props) => {
              return (
                <span className="m-0">
                  {props.headerText}
                  {props.field.toLowerCase() === incidentOrderBy.toLowerCase()
                    ? isAscending
                      ? "↓"
                      : "↑"
                    : ""}
                </span>
              );
            };
          }

          if (field === "name") {
            columnConfig.headerText = "Incident Name";
            columnConfig.width = "710px";
            columnConfig.template = (props) => {
              return (
                <p
                  className="m-0 fw-bold"
                  title={
                    props["doesContainsLinkedIncidents"]
                      ? "This incident contains linked incidents"
                      : ""
                  }
                >
                  {props[field]}
                  {props["doesContainsLinkedIncidents"] && (
                    <img
                      src={linkedIncidentIcon}
                      alt="Linked Incident"
                      className="ms-1"
                    />
                  )}
                </p>
              );
            };
            columnConfig.headerTemplate = (props) => {
              return (
                <span className="m-0">
                  {props.headerText}
                  {props.field.toLowerCase() === incidentOrderBy.toLowerCase()
                    ? isAscending
                      ? "↓"
                      : "↑"
                    : ""}
                </span>
              );
            };
          }

          if (field === "location") {
            columnConfig.width = "200px";
          }

          if (field === "createdOn") {
            columnConfig.headerTemplate = (props) => {
              return (
                <span className="m-0">
                  {props.headerText}
                  {props.field.toLowerCase() === incidentOrderBy.toLowerCase()
                    ? isAscending
                      ? "↓"
                      : "↑"
                    : ""}
                </span>
              );
            };
          }
          if (field === "updatedOn") {
            columnConfig.headerTemplate = (props) => {
              return (
                <span className="m-0">
                  {props.headerText}
                  {props.field.toLowerCase() === incidentOrderBy.toLowerCase()
                    ? isAscending
                      ? "↓"
                      : "↑"
                    : ""}
                </span>
              );
            };
          }

          if (field === "status") {
            columnConfig.template = (props) => {
              let style;
              switch (props.status?.id) {
                case incidentStatus.OPEN:
                  style = "status-pill ongoing";
                  break;
                case incidentStatus.CLOSED:
                  style = "status-pill closed";
                  break;
                case incidentStatus.CLOSURE_INITIATED:
                  style = "status-pill incomplete";
                  break;
                case incidentStatus.CLOSURE_COMPLETED:
                  style = "status-pill complete";
                  break;
                default:
                  style = "";
              }

              return <span className={style}>{props[field]?.description}</span>;
            };
            columnConfig.allowSorting = false;
            columnConfig.headerTemplate = (props) => {
              return <span className="m-0">{props.headerText}</span>;
            };
          }

          return columnConfig;
        })
        .filter(Boolean);

      // columns.push(optionsConfig);
      return columns;
    },
    [incidentOrderBy, isAscending]
  );

  useEffect(() => {
    if (incidents) {
      const data = incidents.ids.map((id) => {
        return incidents.entities[id];
      });
      setIncidentData(data);
      setIncidentColumns(generateColumns(data));
    }
  }, [incidents, generateColumns]);

  useEffect(() => {
    if (statuses) {
      const data = statuses.ids.map((id) => {
        return statuses.entities[id];
      });
      setIncidentStatusData(data);
    }
  }, [statuses]);

  useEffect(() => {
    if (incidentGroups) {
      const data = incidentGroups.ids.map((id) => {
        return incidentGroups.entities[id];
      });
      setIncidentGroupData(data);
    }
  }, [incidentGroups]);

  useEffect(() => {
    if (insights) {
      const data = insights.ids.map((id) => {
        return insights.entities[id];
      });
      setInsightsData(...data);
    }
  }, [insights]);

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  let gridRef = useRef(null);

  const handleSearch = (e) => {
    setPageNumber(1);
    const inputValue = sanitizeInputValue(e.target.value);
    setQuery(inputValue);
  };

  const handlePageChange = (page) => {
    if (page !== undefined || page !== null) {
      setPageNumber(page);
    }
  };

  const getGroups = () => {
    return incidentGroupData?.map((group) => (
      <option key={group.id} value={group.id}>
        {group.description}
      </option>
    ));
  };

  const getTypes = () => {
    if (!filter.groupId) return [];
    const group = incidentGroupData?.find(
      (group) => group.id === parseInt(filter.groupId)
    );
    return group
      ? group.types.map((type) => (
          <option key={type.id} value={type.id}>
            {type.description}
          </option>
        ))
      : [];
  };

  const getSubTypes = () => {
    if (!filter.typeId) return [];
    const group = incidentGroupData?.find(
      (group) => group.id === parseInt(filter.groupId)
    );
    if (!group) return [];
    if (!group.types) return [];
    const type = group.types.find(
      (type) => type.id === parseInt(filter.typeId)
    );
    return type
      ? type.subTypes.map((subType) => (
          <option key={subType.id} value={subType.id}>
            {subType.description}
          </option>
        ))
      : [];
  };

  const handleFilter = (e) => {
    e.preventDefault();

    let value = "";

    if (e.target.open.checked) {
      value = "open";
      setInsightsStatus(value);
    }
    if (e.target.overdue.checked) {
      value = "overdue";
      setInsightsStatus(value);
    }
    if (e.target.notask.checked) {
      value = "notask";
      setInsightsStatus(value);
    }

    const filters = {
      ...filter,
      departmentId: filter?.departmentId?.value,
      subDepartmentId: filter?.subDepartmentId?.value,
      areaId: filter?.areaId?.value,
      costCenterId: filter?.costCenterId?.value,
      createdById: filter?.createdById?.value,
      seniorMangerId: filter?.seniorMangerId?.value,
      localMangerId: filter?.localMangerId?.value,
      incidentAdvisorId: filter?.incidentAdvisorId?.value,
      insightsStatus: value,
    };

    setFilterValues(filters);
    localStorage.setItem(
      "incidentFilters",
      JSON.stringify({
        ...filters,
        departmentId: filter?.departmentId,
        subDepartmentId: filter?.subDepartmentId,
        areaId: filter?.areaId,
        costCenterId: filter?.costCenterId,
        createdById: filter?.createdById,
        localMangerId: filter?.localMangerId,
        seniorMangerId: filter?.seniorMangerId,
        incidentAdvisorId: filter?.incidentAdvisorId,
      })
    );
    setPageNumber(1);
    toggleModal();
  };

  const handleReset = () => {
    setFilter({
      statusId: "",
      typeId: "",
      subTypeId: "",
      groupId: "",
      departmentId: "",
      subDepartmentId: "",
      areaId: "",
      costCenterId: "",
      createdById: "",
      localMangerId: null,
      seniorMangerId: null,
      incidentAdvisorId: null,
    });
    setInsightsStatus("");
    setFilterValues({});
    localStorage.removeItem("incidentFilters");
    setPageNumber(1);
  };

  const handleQuickFilter = (value) => {
    const data = {
      statusId: "",
      typeId: "",
      subTypeId: "",
      groupId: "",
    };
    setInsightsStatus(value);
    setFilterValues({ ...data, insightsStatus: value });
    const incidentFilters = JSON.parse(localStorage.getItem("incidentFilters"));

    localStorage.setItem(
      "incidentFilters",
      JSON.stringify({ ...incidentFilters, insightsStatus: value })
    );
    setPageNumber(1);
  };

  const goToIncidentDetailsPage = (args) => {
    navigate(`view/${args?.data?.guid}`);
  };

  const handleSorting = (args) => {
    if (args.requestType === "sorting") {
      const columnName = args.columnName;
      // const direction = args.direction;

      switch (columnName) {
        case "id":
          setIncidentOrderBy("Id");
          break;
        case "name":
          setIncidentOrderBy("Name");
          break;
        case "createdOn":
          setIncidentOrderBy("CreatedOn");
          break;
        case "updatedOn":
          setIncidentOrderBy("UpdatedOn");
          break;
        default:
          setIncidentOrderBy("");
      }

      if (isAscending) {
        setOrderByType("Asc");
        setIsAscending((prev) => !prev);
      } else {
        setOrderByType("Desc");
        setIsAscending((prev) => !prev);
      }
      args.cancel = true;
    }
  };

  const handleFilterValueChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="incidents">
      <div className="row mb-1 justify-content-between align-items-center">
        <div className="col-auto">
          <h4 className="p-2 m-0">Incidents</h4>
        </div>
        <div className="col-auto">
          <button
            className="btn btn-green btn-icon px-5"
            onClick={() => navigate("/incidents/new")}
          >
            <span className="me-2"> New Incident</span>{" "}
            <img src={addIcon} width={22} alt="" />
          </button>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-12 col-md mb-1">
          <div
            className="card custom-card img-card inprogress-card"
            role="button"
            onClick={() => handleQuickFilter("open")}
          >
            <div className="card-body custom-card-body">
              <p className="fs-4 text-uppercase">open</p>
              <h3>{insightsData?.ongoingCount} </h3>
            </div>
          </div>
        </div>
        <div className="col-12 col-md mb-1">
          <div
            className="card custom-card img-card completed-card"
            role="button"
            onClick={() => handleQuickFilter("overdue")}
          >
            <div className="card-body custom-card-body">
              <p className="fs-4 text-uppercase">tasks due</p>
              <h3>{insightsData?.overdueTasksCount} </h3>
            </div>
          </div>
        </div>
        <div className="col-12 col-md mb-1">
          <div
            className="card custom-card img-card upcoming-card"
            role="button"
            onClick={() => handleQuickFilter("notask")}
          >
            <div className="card-body custom-card-body">
              <p className="fs-4 text-uppercase">no tasks</p>
              <h3>{insightsData?.noTasksCount} </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="card custom-card ">
        <div className="card-body">
          <div className="row justify-content-between align-items-center mb-3">
            <div className="col-auto">
              <h6 className="d-flex align-items-center gap-2">
                Incident List
                {filterValues && hasAnyValue(filterValues) && (
                  <span className="badge rounded-pill text-bg-warning">
                    Filters applied
                  </span>
                )}
              </h6>
            </div>
            <div className="col-auto">
              <div className="d-flex align-items-center">
                <div className="input-group">
                  <label
                    htmlFor="searchIncident"
                    className="input-group-text search-icon-container"
                  >
                    <img
                      src={searchIcon}
                      alt="Search Icon"
                      className="icon-image"
                      width={12}
                    />
                  </label>
                  <input
                    id="searchIncident"
                    type="text"
                    className="form-control search"
                    placeholder="Search Incident"
                    onKeyUp={handleSearch}
                  />
                </div>
                <button className="btn btn-filter" onClick={toggleModal}>
                  <img src={filterIcon} width={34} alt="" />
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {isFetching ? (
                <Loader />
              ) : (
                isSuccess &&
                (incidentData.length > 0 ? (
                  <DataTable
                    data={incidentData}
                    columns={incidentColumns}
                    grid={gridRef}
                    handlePageChange={handlePageChange}
                    currentPage={pageNumber}
                    defaultPaging={false}
                    rowSelected={goToIncidentDetailsPage}
                    handleSorting={handleSorting}
                    allowSorting={true}
                    height={"calc(100vh - 480px)"}
                  />
                ) : (
                  "No Incidents Available..."
                ))
              )}
            </div>
          </div>
          <FilterCoreModal
            isOpen={modalIsOpen}
            toggle={toggleModal}
            title={"Incident Filters"}
          >
            <form onSubmit={handleFilter}>
              <div className="mb-3">
                <label htmlFor="statusId" className="custom-label">
                  Status
                </label>
                <select
                  id="statusId"
                  name="statusId"
                  className="form-select custom-field"
                  value={filter.statusId}
                  onChange={handleFilterValueChange}
                >
                  <option value={""}>Select Status</option>
                  {incidentStatusData?.map((status) => (
                    <option key={status.id} value={status.id}>
                      {status.description}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="groupId" className="custom-label">
                  Group
                </label>
                <select
                  id="groupId"
                  name="groupId"
                  className="form-control custom-field"
                  value={filter.groupId}
                  onChange={handleFilterValueChange}
                >
                  <option value="">Select Group</option>
                  {getGroups()}
                </select>
              </div>
              {filter.groupId && (
                <div className="mb-3">
                  <label htmlFor="typeId" className="custom-label">
                    Type
                  </label>
                  <select
                    id="typeId"
                    name="typeId"
                    className="form-control custom-field"
                    value={filter.typeId}
                    onChange={handleFilterValueChange}
                  >
                    <option value="">Select Type</option>
                    {getTypes()}
                  </select>
                </div>
              )}
              {filter.typeId && (
                <div className="mb-3">
                  <label htmlFor="subTypeId" className="custom-label">
                    Sub Type
                  </label>
                  <select
                    id="subTypeId"
                    name="subTypeId"
                    className="form-control custom-field"
                    value={filter.subTypeId}
                    onChange={handleFilterValueChange}
                  >
                    <option value="">Select Sub Type</option>
                    {getSubTypes()}
                  </select>
                </div>
              )}

              <div>
                <label className="custom-label">Location</label>
                <div className="d-flex gap-2 mb-3">
                  <div className="w-100">
                    <DepartmentSelect
                      value={filter.departmentId}
                      onChange={(value) =>
                        setFilter((prev) => ({
                          ...prev,
                          departmentId: value,
                        }))
                      }
                      placeholder="Department"
                    />
                  </div>
                  <div className="w-100">
                    <SubDepartmentSelect
                      value={filter.subDepartmentId}
                      onChange={(value) =>
                        setFilter((prev) => ({
                          ...prev,
                          subDepartmentId: value,
                        }))
                      }
                      placeholder="Sub Department"
                    />
                  </div>
                </div>
                <div className="d-flex gap-2 mb-3">
                  <div className="w-100">
                    <AreaSelect
                      value={filter.areaId}
                      onChange={(value) =>
                        setFilter((prev) => ({
                          ...prev,
                          areaId: value,
                        }))
                      }
                      placeholder="Area"
                    />
                  </div>
                  <div className="w-100">
                    <CostCentreSelect
                      value={filter.costCenterId}
                      onChange={(value) =>
                        setFilter((prev) => ({
                          ...prev,
                          costCenterId: value,
                        }))
                      }
                      placeholder="Cost Centre"
                    />
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <UserSelect
                  value={filter.createdById}
                  onChange={(value) =>
                    setFilter((prev) => ({
                      ...prev,
                      createdById: value,
                    }))
                  }
                  label={"Submitted By"}
                  placeholder="Select submitted by"
                />
              </div>
              <div className="mb-3">
                <UserSelect
                  value={filter.localMangerId}
                  onChange={(value) =>
                    setFilter((prev) => ({
                      ...prev,
                      localMangerId: value,
                    }))
                  }
                  label={"Local Incident Manager"}
                  placeholder="Select Local Incident Manager"
                />
              </div>
              <div className="mb-3">
                <UserSelect
                  value={filter.seniorMangerId}
                  onChange={(value) =>
                    setFilter((prev) => ({
                      ...prev,
                      seniorMangerId: value,
                    }))
                  }
                  label={"Senior Incident Manager"}
                  placeholder="Select Senior Incident Manager"
                />
              </div>
              <div className="mb-3">
                <UserSelect
                  value={filter.incidentAdvisorId}
                  onChange={(value) =>
                    setFilter((prev) => ({
                      ...prev,
                      incidentAdvisorId: value,
                    }))
                  }
                  label={"Incident Manager (Advisor/Lead)"}
                  placeholder="Select Incident Manager"
                />
              </div>

              {/* <div className="mb-3">
                <label htmlFor="sensitivityLevelId" className="custom-label">
                  Sensitivity Level
                </label>
                <input
                  id="sensitivityLevelId"
                  name="sensitivityLevelId"
                  type="text"
                  className="form-control custom-field"
                />
              </div> */}
              {/* <div className="mb-3">
                <label htmlFor="isNearMiss" className="custom-label me-3">
                  Near Miss
                </label>
                <div className="form-check d-inline-block me-3">
                  <input
                    id="nearMissYes"
                    name="nearMiss"
                    type="checkbox"
                    className="form-check-input"
                    checked={isNearMissYes}
                    onChange={(e) => setIsNearMissYes(e.target.checked)}
                  />
                  <label htmlFor="nearMissYes" className="form-check-label">
                    Yes
                  </label>
                </div>
                <div className="form-check d-inline-block">
                  <input
                    id="nearMissNo"
                    name="nearMiss"
                    type="checkbox"
                    className="form-check-input"
                    checked={isNearMissNo}
                    onChange={(e) => setIsNearMissNo(e.target.checked)}
                  />
                  <label htmlFor="nearMissNo" className="form-check-label">
                    No
                  </label>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label
                      htmlFor="retentionDateAfter"
                      className="custom-label"
                    >
                      Retention Date After
                    </label>
                    <input
                      id="retentionDateAfter"
                      name="retentionDateAfter"
                      type="date"
                      className="form-control custom-field"
                      value={retentionDateAfter}
                      onChange={(e) => setRetentionDateAfter(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label
                      htmlFor="retentionDateBefore"
                      className="custom-label"
                    >
                      Retention Date Before
                    </label>
                    <input
                      id="retentionDateBefore"
                      name="retentionDateBefore"
                      type="date"
                      className="form-control custom-field"
                      value={retentionDateBefore}
                      onChange={(e) => setRetentionDateBefore(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="createdOnAfter" className="custom-label">
                      Created On After
                    </label>
                    <input
                      id="createdOnAfter"
                      name="createdOnAfter"
                      type="date"
                      className="form-control custom-field"
                      value={createdOnAfter}
                      onChange={(e) => setCreatedOnAfter(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="createdOnBefore" className="custom-label">
                      Created On Before
                    </label>
                    <input
                      id="createdOnBefore"
                      name="createdOnBefore"
                      type="date"
                      className="form-control custom-field"
                      value={createdOnBefore}
                      onChange={(e) => setCreatedOnBefore(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="dateAfter" className="custom-label">
                      Date After
                    </label>
                    <input
                      id="dateAfter"
                      name="dateAfter"
                      type="date"
                      className="form-control custom-field"
                      value={dateAfter}
                      onChange={(e) => setDateAfter(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label htmlFor="dateBefore" className="custom-label">
                      Date Before
                    </label>
                    <input
                      id="dateBefore"
                      name="dateBefore"
                      type="date"
                      className="form-control custom-field"
                      onChange={(e) => setDateBefore(e.target.value)}
                    />
                  </div>
                </div>
              </div> */}
              <div className="mb-3">
                <fieldset>
                  <legend className="custom-label">Insight Status</legend>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="insightStatus"
                      id="open"
                      defaultChecked={insightsStatus === "open"}
                      aria-checked={insightsStatus === "open"}
                    />
                    <label className="form-check-label" htmlFor="open">
                      Open
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="insightStatus"
                      id="overdue"
                      defaultChecked={insightsStatus === "overdue"}
                      aria-checked={insightsStatus === "overdue"}
                    />
                    <label className="form-check-label" htmlFor="overdue">
                      Tasks due
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="insightStatus"
                      id="notask"
                      defaultChecked={insightsStatus === "notask"}
                      aria-checked={insightsStatus === "notask"}
                    />
                    <label className="form-check-label" htmlFor="notask">
                      No tasks
                    </label>
                  </div>
                </fieldset>
              </div>
              <div className="row gap-1">
                <div className="col">
                  <button type="submit" className="btn w-100 btn-green">
                    Apply Filters
                  </button>
                </div>
                <div className="col">
                  <button
                    type="reset"
                    className="btn w-100 btn-grey"
                    onClick={handleReset}
                  >
                    Reset Filters
                  </button>
                </div>
              </div>
            </form>
          </FilterCoreModal>
        </div>
      </div>
    </div>
  );
};

export default Incidents;
